<template>
  <div class="remove">
    <th>
      <span>{{label}} <i v-if="icon" :class="icon"></i>
        <button class="btn btn-sm line-3 ml-5" v-if="editMode && !formEdit" v-on:click="modeChange">Edit</button>
        <button class="btn btn-sm line-3 ml-5" v-if="editMode && formEdit" v-on:click="confirmInput">Done</button>
        <!--button class="btn btn-sm line-3 ml-5" v-if="editMode && formEdit" v-on:click="cancelInput">Cancel</button-->
      </span>
    </th>
    <slot></slot>
  </div>

</template>

<script>
export default {
  props: {
      value: Object,
      label: { type: String, default: function(){ return [{}]}},
      icon: { type: String, default: function(){ return ''}},
      fieldMode: { type: Boolean, default: function(){ return false}},
      size: { type: Number, default: function(){ return 6}},
      labelSize: { type: Number, default: function(){ return 4}},
      formSize: { type: Number, default: function(){ return 8}},
      inputSize: { type: Number, default: function(){ return 8}},
      editMode: { type: Boolean, default: function(){ return false}}
  },
  data(){
    return {
      inputText: '',
      formEdit: false,
      user: {name: 'euizong'}
    }
  },
  mounted(){
    this.$nextTick(function () {
 	 // remove unwanted element all other is work jQuery required
	  	$('.remove').contents().unwrap();
  	})
    this.$on("cancelInput", this.cancelInput);
    this.$on("confirmInput", this.confirmInput);
    this.$on("input", this.updateInput);
  },
  methods:{
    cancelInput(){
      this.formEdit = false;
      this.$slots.default[0].componentInstance.formEdit = this.formEdit;
    },
    confirmInput(data){
      this.formEdit = false;

      if(this.$slots.default[0].componentInstance){
        this.$slots.default[0].componentInstance.formEdit = this.formEdit;
        if(!data.childrenCall)
          this.$slots.default[0].componentInstance.confirmInput();
      }else if(this.$slots.default[0].children[0].componentInstance){
        this.$slots.default[0].children[0].componentInstance.formEdit= this.formEdit;
        if(!data.childrenCall)
          this.$slots.default[0].children[0].componentInstance.confirmInput();
      }
    },
    modeChange(){
      this.formEdit = !this.formEdit;

      if(this.$slots.default[0].componentInstance){
        this.$slots.default[0].componentInstance.formEdit = this.formEdit;
      }else if(this.$slots.default[0].children[0].componentInstance){
        this.$slots.default[0].children[0].componentInstance.formEdit= this.formEdit;
      }
    },
  },
  component: {

  }
}
</script>

<style>

</style>
